// extracted by css-extract-rspack-plugin
export default {"notificationIndicator":"ShortcutOptionsButton-module__notificationIndicator__pLblZ"};